<template>
    <div class="detail-index dis-align" :class="{'show': show}">
        <div class="detail-i-content">
            <p class="d-i-c-t1"><span :class="[colorName]">{{score}}</span>分</p>
            <p class="d-i-c-t2">你打败了全国<span>{{webIndex}}%</span>的竞争对手</p>

            <div class="detail-i-close" @click="close()"></div>
        </div>
    </div>
</template>

<script>
    import { mapState, mapActions } from 'vuex'
    import _ from 'lodash'
    export default {
        props: ['isFinish'],
        data() {
            return {
                show: false,
                colorName: ''
            }
        },
        watch: {
            isFinish(newVal) {
                if (newVal) {
                    this.hasWebIndex();
                }
            }
        },
        computed: {
            ...mapState(['user']),
            ...mapState('check', {
                score: state => state.progressData.score,
                webIndex: state => state.webIndex,
                token: state => state.token
            })
        },
        methods: {
            ...mapActions('check', ['getWebIndex']),
            setStatus(status) {
                this.show = status;
            },
            getCacheWebIndex(isAll) {
                let indexData = localStorage['webchecker-index'] || '[]';
                indexData = JSON.parse(indexData);
                return isAll ? indexData : _.find(indexData, {id: this.user._id + this.token});
            },
            setCacheWebIndex() {
                let indexData = this.getCacheWebIndex(true);
                let id = this.user._id + this.token;
                _.remove(indexData, item => item.id === id);
                indexData.push({id, time: new Date()});
                localStorage['webchecker-index'] = JSON.stringify(indexData);
            },
            hasWebIndex() {
                let item = this.getCacheWebIndex();
                if (!item) {
                    this.setCacheWebIndex();
                    this.showWebIndex();
                } else {
                    let itemDay = new Date(item.time).getDay();
                    if (new Date().getDay() - itemDay > 0) {
                        this.setCacheWebIndex();
                        this.showWebIndex();
                    }
                }
            },
            showWebIndex() {
                this.getWebIndex().then(() => {
                    if (this.score >= 60) {
                        this.colorName = 'color1';
                    } else if (this.score >= 40 && this.score < 60) {
                        this.colorName = 'color2';
                    } else {
                        this.colorName = 'color3';
                    }
                    this.setStatus(true);
                });
            },
            close() {
                this.setStatus(false);
            }
        }
    }
</script>

<style lang="scss" scoped>
    .detail-index {
        display: none;
        position: fixed;
        top: 0;
        left: 0;
        z-index: 100;
        width: 100%;
        height: 100%;
        text-align: center;
        background-color: rgba(0,0,0,.6);

        &.show {
            display: block;
        }
    }
    .detail-i-content {
        position: relative;
        display: inline-block;
        width: 24.85rem;
        height: 17.3rem;
        vertical-align: middle;
        background: url("../../content/images/webindex.png") no-repeat;
        background-size: cover;

        .d-i-c-t1 {
            margin-top: 2.3rem;
            font-size: 1.2rem;
            font-weight: bold;
            color: #575757;
            span {
                font-size: 5rem;
                margin-right: 8px;
            }
        }

        .d-i-c-t2 {
            margin-top: 1rem;
            font-size: 1.2rem;
            color: #575757;
            span {
                color: #f06e6c;
                margin: 0 5px;
            }
        }
    }

    .detail-i-close {
        position: absolute;
        top: 15px;
        right: -3.2rem;
        width: 2rem;
        height: 2rem;
        background: url("../../content/images/webindex-close.png") no-repeat;
        background-size: cover;
        cursor: pointer;
    }
    .color1 {
        color: #88bb5e;
    }
    .color2 {
        color: #e8af68;
    }
    .color3 {
        color: #f06e6c;
    }
</style>


// WEBPACK FOOTER //
// app/view/detail/DetailIndex.vue